(function($) {

	$.fn.msxidatepicker = function(options) {
		// build main options before element iteration
		var opts = $.extend(true, {}, $.fn.msxidatepicker.defaults, options);

        function init($this) {
            // build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            var value = $this.val();
            if (eOpts['create-alt-field']) {
                var id = $this.attr('id') + eOpts['alt-field-postfix'];
                var name = $this.attr('name') + eOpts['alt-field-postfix'];
                // replace . [ ] with some simple thing that won't mess up jQuery selectors
                var escapedAltFieldId = id.replace(/[\[\]\.]/g, "__");
                // Append timestamp to the ID to make sure it is unique on the page, in case we are inside a dialog,
                // otherwise if multiple dialogs are opened containing the same form then the wrong field gets updated
                escapedAltFieldId = escapedAltFieldId + '-' + new Date().getTime();

                $this.attr({
                    'id':escapedAltFieldId + '-date-picker',
                    'name':name + '-date-picker'
                });

                var $altField = $('<input type="hidden" />');
                $altField.attr({
                    'id':escapedAltFieldId,
                    'name':name
                });
                if (value && value.match('\\d{4}-\\d{2}-\\d{2}')) {
                    $altField.val(value);
                }
                $altField.insertBefore($this);
                eOpts = $.extend(true, eOpts, {datepicker:{altField:'#' + escapedAltFieldId}});

                // temp disable the date-picker field as we don't need it to be submitted with the form
                $this.excludeSubmit();

                if(eOpts['alt-field-postfix'] === '-dateonly') {

                    // temp disable the -dateonly field as we don't need it to be submitted with the form
                    $altField.excludeSubmit();
                }
            }

            //read date value from input box and set it to the hidden field
            $this.keyup(function () {
                var dateValue = $this.val();
                $altField.val(dateValue);
            });

            $this.attr('autocomplete', 'off');

            $this.datepicker(eOpts['datepicker']);

            var placeholder;
            if (eOpts['show-placeholder']) {
                // in dateFormat 'yy' is 4 digits. Confusing to user so replace with 'yyyy'
                placeholder = $this.datepicker('option', "dateFormat").replace('yy', 'yyyy');
                $this.attr('placeholder', placeholder);
            }

            if (eOpts['create-alt-field'] && value) {
                if (value.match('\\d{4}-\\d{2}-\\d{2}')) {
                    // Parse using the ISO format
                    $this.datepicker('setDate', $.datepicker.parseDate('yy-mm-dd', value.split(' ')[0]));
                }
            }

            if (value.match('\\d{4}-\\d{2}-\\d{2}')) {
                updateMinAndMax($(this), $.datepicker.parseDate('yy-mm-dd', value.split(' ')[0]));
            }


            if (eOpts['tracked-date']) {
                var $trackedDate = $(eOpts['tracked-date']);
                // Listen to changes on tracked date time and update this date time accordingly
                $trackedDate.data('value', $trackedDate.val()).change(function () {
                    var previousDate = fixIsoDateFormat($trackedDate.data('value'));
                    var nextDate = fixIsoDateFormat($trackedDate.val());
                    var thisDate = fixIsoDateFormat($altField.val());
                    var newDate = new Date(new Date(thisDate).getTime() + new Date(nextDate).getTime() - new Date(previousDate).getTime());
                    setDatePickerDateAndTriggerOnClose($this, newDate);
                    $trackedDate.data('value', $trackedDate.val());
                });
            }
        }
        // init async to avoid unresponsive script (when there are lots on the page)
        $.fn.msxidatepicker.afterInitCompleted = false;
        return this.eachAsync({
            loop: function(){
                init($(this));
            },
            end: function()
            {
                for(var i = 0; i < $.fn.msxidatepicker.afterInit.length; i++)
                {
                    $.fn.msxidatepicker.afterInit[i].call();

                }
                // clear global array after use as datepickers can be instantiated multiple times within a screen
                // (e.g. during page load and when adding event slots when contact schedule is extended)
                $.fn.msxidatepicker.afterInit = [];
                $.fn.msxidatepicker.afterInitCompleted = true;
            }
        });
	};
	//
	// plugin defaults
	//
	$.fn.msxidatepicker.defaults = {
            'create-alt-field': true,
            'show-placeholder': true,
            'alt-field-postfix': '', /* This will be postfixed to the alt field name. Used by the time picker to allow it to manage the value submitted */
            datepicker: {
                altFormat: "yy-mm-dd",
                // doNothing onSelect as datepicker triggers change event rather than onSelect if no callback defined and we want change event to be triggered by onClose handler
                onSelect: function(){},
                onClose: function(selectedDate){
                    var $datepicker = $(this);
                    $datepicker.prev('input[type=hidden]').trigger('change');
                    $datepicker.trigger('change');

                    updateMinAndMax($datepicker, selectedDate);

                    // Datepicker changes date value after the focusout event has fired
                    // so placeholder class needs manually removing.
                    $datepicker.removeClass("placeholder");
                },
                beforeShow: function(input) {
                    if ($(input).attr('readonly')) { return false; }
                },
                // prevent tooltips on next and previous button now that we have raised the z-index above tooltips (FPM-5957)
                nextText: ' ',
                prevText: ' '
            }
	};

    function fixIsoDateFormat(dateString)
    {
        if(dateString.length == 15)
        {
            return dateString.substring(0,10) + 'T0' + dateString.substring(11);
        }
        else
        {
            return dateString.substring(0, 10) + 'T' + dateString.substring(11);
        }
    }

    function updateMinAndMax($datepicker, selectedDate) {
        if ($datepicker.hasClass("form-date-range-left") || $datepicker.hasClass("form-date-range-right")) {
            var $parent = $datepicker.closest(".form-date-range");
            if ($parent.length > 0) {
                //Date range component.
                if ($datepicker.hasClass("form-date-range-left")) {
                    var $right = $parent.find(".form-date-range-right");

                    $right.datepicker("option", "minDate", selectedDate);
                }
                if ($datepicker.hasClass("form-date-range-right")) {
                    var $left = $parent.find(".form-date-range-left");

                    $left.datepicker("option", "maxDate", selectedDate);
                    // The left date will have been inited before the right date, so call update on left date to set min on right date
                    updateMinAndMax($left, $left.datepicker('getDate'));
                }
            }
        }
    }

    function setDatePickerDateAndTriggerOnClose($datepicker, date) {
        var existingDate = $datepicker.datepicker("getDate");
        if (existingDate.getTime() != date.getTime()) {
            $datepicker.datepicker("setDate", date);
            // calling setDate does not trigger the onClose callback, which is necessary to keep inputs in sync
            var inst = $.datepicker._getInst($datepicker[0]);
            $.datepicker._get(inst, 'onClose').apply(inst.input[0], [date, inst]);
        }
    }

    // msxidatepicker afterInit callback functions.
    // Other plugins can extend this using:
    // $.fn.msxidatepicker.afterInit.push(someFunction);
    //
    $.fn.msxidatepicker.afterInit = [];
    $.fn.msxidatepicker.afterInitCompleted = false;
})(jQuery);